import DjangoMessages from 'components/DjangoMessages';
import Dropdown from 'components/Form/Dropdown';
import FormActions from 'components/Form/FormActions';
import FormResult from 'components/Form/FormResult';
import SubmitButton from 'components/Form/SubmitButton';
import SideBySide from 'components/Layout/SideBySide';
import LinkButton from 'components/LinkButton';
import NavigationTabs from 'components/Navigation/NavigationTabs';
import SectionHeader from 'components/SectionHeader';
import {useState} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {useBackend} from 'state/backend';
import {c, t} from 'ttag';
import {setUrl} from 'utils/request';
import {onApiErrorAxios} from 'utils/request-axios/utils';

import {BackendData} from '../../types';
import {sendingSettingsLinks} from '../../utils';
import useSendingSettings from '../services';

const DefaultReplyToAddress = () => {
    const {data} = useBackend<BackendData>();
    const options = [
        {
            label: t`None`,
            value: '',
        } as BackendData['data']['defaultReplyToAddressValues'][0],
        ...data.defaultReplyToAddressValues,
    ];
    return (
        <Dropdown
            helpText={t`Set a company contact as the default Reply-To address for outgoing emails.`}
            label={t`Default Reply-To Address`}
            name="defaultReplyToContact"
            options={options}
            type="select"
        />
    );
};

export type FormData = {
    defaultReplyToContact: string;
};

const useInitialValue = (): FormData => {
    const {data} = useBackend<BackendData>();
    const [result] = useState<FormData>(() => {
        return {
            defaultReplyToContact: data.defaultReplyToContact?.mid || '',
        };
    });
    return result;
};

const Page = () => {
    const initialData = useInitialValue();
    const methods = useForm<FormData>({
        defaultValues: initialData,
        shouldUnregister: true,
    });
    const api = useSendingSettings();

    const disableSubmit = methods.formState.isSubmitting;

    const handleSubmit = async (formData: FormData) => {
        await api
            .mutateAsync(formData)
            .then(() => {
                setUrl(sendingSettingsLinks.sendingSettingsView);
            })
            .catch(onApiErrorAxios(methods));
    };

    return (
        <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(handleSubmit)}>
                <DjangoMessages className="mb-4" />
                <NavigationTabs.Partner selection="sending_settings" />
                <div>
                    <SectionHeader
                        title={c('document-settings').t`Email Settings`}
                    />
                    <SideBySide
                        className="mt-4"
                        classNameLabel="w-[14rem] max-w-[14rem]"
                    >
                        <DefaultReplyToAddress />
                        <FormResult />
                        <FormActions align="left">
                            <SubmitButton
                                disabled={disableSubmit}
                            >{t`Save`}</SubmitButton>
                            <LinkButton
                                href={sendingSettingsLinks.sendingSettingsView}
                            >{t`Cancel`}</LinkButton>
                        </FormActions>
                    </SideBySide>
                </div>
            </form>
        </FormProvider>
    );
};
export default Page;
